import collectionArt0 from "@/assets/collectionArt/0.jpg";
import collectionArt1 from "@/assets/collectionArt/1.jpg";
import collectionArt2 from "@/assets/collectionArt/2.jpg";
import collectionArt3 from "@/assets/collectionArt/3.jpg";
import collectionArt4 from "@/assets/collectionArt/4.jpg";
import collectionArt5 from "@/assets/collectionArt/5.jpg";
import collectionArt6 from "@/assets/collectionArt/6.jpg";
import collectionArt7 from "@/assets/collectionArt/7.jpg";
import collectionArt8 from "@/assets/collectionArt/8.jpg";
import collectionArt9 from "@/assets/collectionArt/9.jpg";
import collectionArt10 from "@/assets/collectionArt/10.jpg";
import collectionArt11 from "@/assets/collectionArt/11.jpg";
import collectionArt12 from "@/assets/collectionArt/12.jpg";
import collectionArt13 from "@/assets/collectionArt/13.jpg";
import collectionArt14 from "@/assets/collectionArt/14.jpg";
import collectionArt15 from "@/assets/collectionArt/15.jpg";
import collectionArt16 from "@/assets/collectionArt/16.jpg";
import collectionArt17 from "@/assets/collectionArt/17.jpg";
import collectionArt18 from "@/assets/collectionArt/18.jpg";
import collectionArt19 from "@/assets/collectionArt/19.jpg";
import collectionArt20 from "@/assets/collectionArt/20.jpg";
import collectionArt21 from "@/assets/collectionArt/21.jpg";
import collectionArt22 from "@/assets/collectionArt/22.jpg";
import collectionArt23 from "@/assets/collectionArt/23.jpg";
import collectionArt24 from "@/assets/collectionArt/24.jpg";
import collectionArt25 from "@/assets/collectionArt/25.jpg";
import collectionArt26 from "@/assets/collectionArt/26.jpg";
import collectionArt27 from "@/assets/collectionArt/27.jpg";
import collectionArt28 from "@/assets/collectionArt/28.jpg";
import collectionArt29 from "@/assets/collectionArt/29.jpg";
import collectionArt30 from "@/assets/collectionArt/30.jpg";
import collectionArt31 from "@/assets/collectionArt/31.jpg";
import collectionArt32 from "@/assets/collectionArt/32.jpg";
import collectionArt33 from "@/assets/collectionArt/33.jpg";
import collectionArt34 from "@/assets/collectionArt/34.jpg";
import collectionArt35 from "@/assets/collectionArt/35.jpg";
import collectionArt36 from "@/assets/collectionArt/36.jpg";
import collectionArt37 from "@/assets/collectionArt/37.jpg";
import collectionArt38 from "@/assets/collectionArt/38.jpg";
import collectionArt39 from "@/assets/collectionArt/39.jpg";
import collectionArt40 from "@/assets/collectionArt/40.jpg";
import collectionArt41 from "@/assets/collectionArt/41.jpg";
import collectionArt42 from "@/assets/collectionArt/42.jpg";
import collectionArt43 from "@/assets/collectionArt/43.jpg";
import collectionArt44 from "@/assets/collectionArt/44.jpg";
import collectionArt45 from "@/assets/collectionArt/45.jpg";
import collectionArt46 from "@/assets/collectionArt/46.jpg";
import collectionArt47 from "@/assets/collectionArt/47.jpg";
import collectionArt48 from "@/assets/collectionArt/48.jpg";
import collectionArt49 from "@/assets/collectionArt/49.jpg";
import collectionArt50 from "@/assets/collectionArt/50.jpg";
import collectionArt51 from "@/assets/collectionArt/51.jpg";
import collectionArt52 from "@/assets/collectionArt/52.jpg";
import collectionArt53 from "@/assets/collectionArt/53.jpg";
import collectionArt54 from "@/assets/collectionArt/54.jpg";
import collectionArt55 from "@/assets/collectionArt/55.jpg";
import collectionArt56 from "@/assets/collectionArt/56.jpg";
import collectionArt57 from "@/assets/collectionArt/57.jpg";
import collectionArt58 from "@/assets/collectionArt/58.jpg";
import collectionArt59 from "@/assets/collectionArt/59.jpg";
import collectionArt60 from "@/assets/collectionArt/60.jpg";
import collectionArt61 from "@/assets/collectionArt/61.jpg";
import collectionArt62 from "@/assets/collectionArt/62.jpg";
import collectionArt63 from "@/assets/collectionArt/63.jpg";
import collectionArt64 from "@/assets/collectionArt/64.jpg";
import collectionArt65 from "@/assets/collectionArt/65.jpg";
import collectionArt66 from "@/assets/collectionArt/66.jpg";
import collectionArt67 from "@/assets/collectionArt/67.jpg";
import collectionArt68 from "@/assets/collectionArt/68.jpg";
import collectionArt69 from "@/assets/collectionArt/69.jpg";
import collectionArt70 from "@/assets/collectionArt/70.jpg";
import collectionArt71 from "@/assets/collectionArt/71.jpg";
import collectionArt72 from "@/assets/collectionArt/72.jpg";
import collectionArt73 from "@/assets/collectionArt/73.jpg";
import collectionArt74 from "@/assets/collectionArt/74.jpg";
import collectionArt75 from "@/assets/collectionArt/75.jpg";
import collectionArt76 from "@/assets/collectionArt/76.jpg";
import collectionArt77 from "@/assets/collectionArt/77.jpg";
import collectionArt78 from "@/assets/collectionArt/78.jpg";
import collectionArt79 from "@/assets/collectionArt/79.jpg";
import collectionArt80 from "@/assets/collectionArt/80.jpg";
import collectionArt81 from "@/assets/collectionArt/81.jpg";
import collectionArt82 from "@/assets/collectionArt/82.jpg";
import collectionArt83 from "@/assets/collectionArt/83.jpg";
import collectionArt84 from "@/assets/collectionArt/84.jpg";
import collectionArt85 from "@/assets/collectionArt/85.jpg";
import collectionArt86 from "@/assets/collectionArt/86.jpg";
import collectionArt87 from "@/assets/collectionArt/87.jpg";
import collectionArt88 from "@/assets/collectionArt/88.jpg";
import collectionArt89 from "@/assets/collectionArt/89.jpg";
import collectionArt90 from "@/assets/collectionArt/90.jpg";
import collectionArt91 from "@/assets/collectionArt/91.jpg";
import collectionArt92 from "@/assets/collectionArt/92.jpg";
import collectionArt93 from "@/assets/collectionArt/93.jpg";
import collectionArt94 from "@/assets/collectionArt/94.jpg";
import collectionArt95 from "@/assets/collectionArt/95.jpg";
import collectionArt96 from "@/assets/collectionArt/96.jpg";
import collectionArt97 from "@/assets/collectionArt/97.jpg";
import collectionArt98 from "@/assets/collectionArt/98.jpg";
import collectionArt99 from "@/assets/collectionArt/99.jpg";
import collectionArt100 from "@/assets/collectionArt/100.jpg";
import collectionArt101 from "@/assets/collectionArt/101.jpg";
import collectionArt102 from "@/assets/collectionArt/102.jpg";
import collectionArt103 from "@/assets/collectionArt/103.jpg";
import collectionArt104 from "@/assets/collectionArt/104.jpg";
import collectionArt105 from "@/assets/collectionArt/105.jpg";
import collectionArt106 from "@/assets/collectionArt/106.jpg";
import collectionArt107 from "@/assets/collectionArt/107.jpg";
import collectionArt108 from "@/assets/collectionArt/108.jpg";
import collectionArt109 from "@/assets/collectionArt/109.jpg";
import collectionArt110 from "@/assets/collectionArt/110.jpg";
import collectionArt111 from "@/assets/collectionArt/111.jpg";
import collectionArt112 from "@/assets/collectionArt/112.jpg";
import collectionArt113 from "@/assets/collectionArt/113.jpg";
import collectionArt114 from "@/assets/collectionArt/114.jpg";
import collectionArt115 from "@/assets/collectionArt/115.jpg";
import collectionArt116 from "@/assets/collectionArt/116.jpg";
import collectionArt117 from "@/assets/collectionArt/117.jpg";
import collectionArt118 from "@/assets/collectionArt/118.jpg";
import collectionArt119 from "@/assets/collectionArt/119.jpg";
import collectionArt120 from "@/assets/collectionArt/120.jpg";
import collectionArt121 from "@/assets/collectionArt/121.jpg";
import collectionArt122 from "@/assets/collectionArt/122.jpg";
import collectionArt123 from "@/assets/collectionArt/123.jpg";
import collectionArt124 from "@/assets/collectionArt/124.jpg";
import collectionArt125 from "@/assets/collectionArt/125.jpg";
import collectionArt126 from "@/assets/collectionArt/126.jpg";
import collectionArt127 from "@/assets/collectionArt/127.jpg";
import collectionArt128 from "@/assets/collectionArt/128.jpg";
import collectionArt129 from "@/assets/collectionArt/129.jpg";
import collectionArt130 from "@/assets/collectionArt/130.jpg";
import collectionArt131 from "@/assets/collectionArt/131.jpg";
import collectionArt132 from "@/assets/collectionArt/132.jpg";
import collectionArt133 from "@/assets/collectionArt/133.jpg";
import collectionArt134 from "@/assets/collectionArt/134.jpg";
import collectionArt135 from "@/assets/collectionArt/135.jpg";
import collectionArt136 from "@/assets/collectionArt/136.jpg";
import collectionArt137 from "@/assets/collectionArt/137.jpg";
import collectionArt138 from "@/assets/collectionArt/138.jpg";
import collectionArt139 from "@/assets/collectionArt/139.jpg";
import collectionArt140 from "@/assets/collectionArt/140.jpg";
import collectionArt141 from "@/assets/collectionArt/141.jpg";
import collectionArt142 from "@/assets/collectionArt/142.jpg";
import collectionArt143 from "@/assets/collectionArt/143.jpg";
import collectionArt144 from "@/assets/collectionArt/144.jpg";
import collectionArt145 from "@/assets/collectionArt/145.jpg";
import collectionArt146 from "@/assets/collectionArt/146.jpg";
import collectionArt147 from "@/assets/collectionArt/147.jpg";
import collectionArt148 from "@/assets/collectionArt/148.jpg";
import collectionArt149 from "@/assets/collectionArt/149.jpg";
import collectionArt150 from "@/assets/collectionArt/150.jpg";
import collectionArt151 from "@/assets/collectionArt/151.jpg";
import collectionArt152 from "@/assets/collectionArt/152.jpg";
import collectionArt153 from "@/assets/collectionArt/153.jpg";
import collectionArt154 from "@/assets/collectionArt/154.jpg";
import collectionArt155 from "@/assets/collectionArt/155.jpg";
import collectionArt156 from "@/assets/collectionArt/156.jpg";
import collectionArt157 from "@/assets/collectionArt/157.jpg";
import collectionArt158 from "@/assets/collectionArt/158.jpg";
import collectionArt159 from "@/assets/collectionArt/159.jpg";
import collectionArt160 from "@/assets/collectionArt/160.jpg";
import collectionArt161 from "@/assets/collectionArt/161.jpg";
import collectionArt162 from "@/assets/collectionArt/162.jpg";
import collectionArt163 from "@/assets/collectionArt/163.jpg";
import collectionArt164 from "@/assets/collectionArt/164.jpg";
import collectionArt165 from "@/assets/collectionArt/165.jpg";
import collectionArt166 from "@/assets/collectionArt/166.jpg";
import collectionArt167 from "@/assets/collectionArt/167.jpg";
import collectionArt168 from "@/assets/collectionArt/168.jpg";
import collectionArt169 from "@/assets/collectionArt/169.jpg";
import collectionArt170 from "@/assets/collectionArt/170.jpg";
import collectionArt171 from "@/assets/collectionArt/171.jpg";
import collectionArt172 from "@/assets/collectionArt/172.jpg";
import collectionArt173 from "@/assets/collectionArt/173.jpg";
import collectionArt174 from "@/assets/collectionArt/174.jpg";
import collectionArt175 from "@/assets/collectionArt/175.jpg";
import collectionArt176 from "@/assets/collectionArt/176.jpg";
import collectionArt177 from "@/assets/collectionArt/177.jpg";
import collectionArt178 from "@/assets/collectionArt/178.jpg";
import collectionArt179 from "@/assets/collectionArt/179.jpg";
import collectionArt180 from "@/assets/collectionArt/180.jpg";
import collectionArt181 from "@/assets/collectionArt/181.jpg";
import collectionArt182 from "@/assets/collectionArt/182.jpg";
import collectionArt183 from "@/assets/collectionArt/183.jpg";
import collectionArt184 from "@/assets/collectionArt/184.jpg";
import collectionArt185 from "@/assets/collectionArt/185.jpg";
import collectionArt186 from "@/assets/collectionArt/186.jpg";
import collectionArt187 from "@/assets/collectionArt/187.jpg";
import collectionArt188 from "@/assets/collectionArt/188.jpg";
import collectionArt189 from "@/assets/collectionArt/189.jpg";
import collectionArt190 from "@/assets/collectionArt/190.jpg";
import collectionArt191 from "@/assets/collectionArt/191.jpg";
import collectionArt192 from "@/assets/collectionArt/192.jpg";
import collectionArt193 from "@/assets/collectionArt/193.jpg";
import collectionArt194 from "@/assets/collectionArt/194.jpg";
import collectionArt195 from "@/assets/collectionArt/195.jpg";
import collectionArt196 from "@/assets/collectionArt/196.jpg";
import collectionArt197 from "@/assets/collectionArt/197.jpg";
import collectionArt198 from "@/assets/collectionArt/198.jpg";
import collectionArt199 from "@/assets/collectionArt/199.jpg";
import collectionArt200 from "@/assets/collectionArt/200.jpg";
import collectionArt201 from "@/assets/collectionArt/201.jpg";
import collectionArt202 from "@/assets/collectionArt/202.jpg";
import collectionArt203 from "@/assets/collectionArt/203.jpg";
import collectionArt204 from "@/assets/collectionArt/204.jpg";
import collectionArt205 from "@/assets/collectionArt/205.jpg";
import collectionArt206 from "@/assets/collectionArt/206.jpg";
import collectionArt207 from "@/assets/collectionArt/207.jpg";
import collectionArt208 from "@/assets/collectionArt/208.jpg";
import collectionArt209 from "@/assets/collectionArt/209.jpg";
import collectionArt210 from "@/assets/collectionArt/210.jpg";
import collectionArt211 from "@/assets/collectionArt/211.jpg";
import collectionArt212 from "@/assets/collectionArt/212.jpg";
import collectionArt213 from "@/assets/collectionArt/213.jpg";
import collectionArt214 from "@/assets/collectionArt/214.jpg";
import collectionArt215 from "@/assets/collectionArt/215.jpg";
import collectionArt216 from "@/assets/collectionArt/216.jpg";
import collectionArt217 from "@/assets/collectionArt/217.jpg";
import collectionArt218 from "@/assets/collectionArt/218.jpg";
import collectionArt219 from "@/assets/collectionArt/219.jpg";
import collectionArt220 from "@/assets/collectionArt/220.jpg";
import collectionArt221 from "@/assets/collectionArt/221.jpg";
import collectionArt222 from "@/assets/collectionArt/222.jpg";
import collectionArt223 from "@/assets/collectionArt/223.jpg";
import collectionArt224 from "@/assets/collectionArt/224.jpg";
import collectionArt225 from "@/assets/collectionArt/225.jpg";
import collectionArt226 from "@/assets/collectionArt/226.jpg";
import collectionArt227 from "@/assets/collectionArt/227.jpg";
import collectionArt228 from "@/assets/collectionArt/228.jpg";
import collectionArt229 from "@/assets/collectionArt/229.jpg";
import collectionArt230 from "@/assets/collectionArt/230.jpg";
import collectionArt231 from "@/assets/collectionArt/231.jpg";
import collectionArt232 from "@/assets/collectionArt/232.jpg";
import collectionArt233 from "@/assets/collectionArt/233.jpg";
import collectionArt234 from "@/assets/collectionArt/234.jpg";
import collectionArt235 from "@/assets/collectionArt/235.jpg";
import collectionArt236 from "@/assets/collectionArt/236.jpg";
import collectionArt237 from "@/assets/collectionArt/237.jpg";

export const collectionArts = [
	collectionArt0,
	collectionArt1,
	collectionArt2,
	collectionArt3,
	collectionArt4,
	collectionArt5,
	collectionArt6,
	collectionArt7,
	collectionArt8,
	collectionArt9,
	collectionArt10,
	collectionArt11,
	collectionArt12,
	collectionArt13,
	collectionArt14,
	collectionArt15,
	collectionArt16,
	collectionArt17,
	collectionArt18,
	collectionArt19,
	collectionArt20,
	collectionArt21,
	collectionArt22,
	collectionArt23,
	collectionArt24,
	collectionArt25,
	collectionArt26,
	collectionArt27,
	collectionArt28,
	collectionArt29,
	collectionArt30,
	collectionArt31,
	collectionArt32,
	collectionArt33,
	collectionArt34,
	collectionArt35,
	collectionArt36,
	collectionArt37,
	collectionArt38,
	collectionArt39,
	collectionArt40,
	collectionArt41,
	collectionArt42,
	collectionArt43,
	collectionArt44,
	collectionArt45,
	collectionArt46,
	collectionArt47,
	collectionArt48,
	collectionArt49,
	collectionArt50,
	collectionArt51,
	collectionArt52,
	collectionArt53,
	collectionArt54,
	collectionArt55,
	collectionArt56,
	collectionArt57,
	collectionArt58,
	collectionArt59,
	collectionArt60,
	collectionArt61,
	collectionArt62,
	collectionArt63,
	collectionArt64,
	collectionArt65,
	collectionArt66,
	collectionArt67,
	collectionArt68,
	collectionArt69,
	collectionArt70,
	collectionArt71,
	collectionArt72,
	collectionArt73,
	collectionArt74,
	collectionArt75,
	collectionArt76,
	collectionArt77,
	collectionArt78,
	collectionArt79,
	collectionArt80,
	collectionArt81,
	collectionArt82,
	collectionArt83,
	collectionArt84,
	collectionArt85,
	collectionArt86,
	collectionArt87,
	collectionArt88,
	collectionArt89,
	collectionArt90,
	collectionArt91,
	collectionArt92,
	collectionArt93,
	collectionArt94,
	collectionArt95,
	collectionArt96,
	collectionArt97,
	collectionArt98,
	collectionArt99,
	collectionArt100,
	collectionArt101,
	collectionArt102,
	collectionArt103,
	collectionArt104,
	collectionArt105,
	collectionArt106,
	collectionArt107,
	collectionArt108,
	collectionArt109,
	collectionArt110,
	collectionArt111,
	collectionArt112,
	collectionArt113,
	collectionArt114,
	collectionArt115,
	collectionArt116,
	collectionArt117,
	collectionArt118,
	collectionArt119,
	collectionArt120,
	collectionArt121,
	collectionArt122,
	collectionArt123,
	collectionArt124,
	collectionArt125,
	collectionArt126,
	collectionArt127,
	collectionArt128,
	collectionArt129,
	collectionArt130,
	collectionArt131,
	collectionArt132,
	collectionArt133,
	collectionArt134,
	collectionArt135,
	collectionArt136,
	collectionArt137,
	collectionArt138,
	collectionArt139,
	collectionArt140,
	collectionArt141,
	collectionArt142,
	collectionArt143,
	collectionArt144,
	collectionArt145,
	collectionArt146,
	collectionArt147,
	collectionArt148,
	collectionArt149,
	collectionArt150,
	collectionArt151,
	collectionArt152,
	collectionArt153,
	collectionArt154,
	collectionArt155,
	collectionArt156,
	collectionArt157,
	collectionArt158,
	collectionArt159,
	collectionArt160,
	collectionArt161,
	collectionArt162,
	collectionArt163,
	collectionArt164,
	collectionArt165,
	collectionArt166,
	collectionArt167,
	collectionArt168,
	collectionArt169,
	collectionArt170,
	collectionArt171,
	collectionArt172,
	collectionArt173,
	collectionArt174,
	collectionArt175,
	collectionArt176,
	collectionArt177,
	collectionArt178,
	collectionArt179,
	collectionArt180,
	collectionArt181,
	collectionArt182,
	collectionArt183,
	collectionArt184,
	collectionArt185,
	collectionArt186,
	collectionArt187,
	collectionArt188,
	collectionArt189,
	collectionArt190,
	collectionArt191,
	collectionArt192,
	collectionArt193,
	collectionArt194,
	collectionArt195,
	collectionArt196,
	collectionArt197,
	collectionArt198,
	collectionArt199,
	collectionArt200,
	collectionArt201,
	collectionArt202,
	collectionArt203,
	collectionArt204,
	collectionArt205,
	collectionArt206,
	collectionArt207,
	collectionArt208,
	collectionArt209,
	collectionArt210,
	collectionArt211,
	collectionArt212,
	collectionArt213,
	collectionArt214,
	collectionArt215,
	collectionArt216,
	collectionArt217,
	collectionArt218,
	collectionArt219,
	collectionArt220,
	collectionArt221,
	collectionArt222,
	collectionArt223,
	collectionArt224,
	collectionArt225,
	collectionArt226,
	collectionArt227,
	collectionArt228,
	collectionArt229,
	collectionArt230,
	collectionArt231,
	collectionArt232,
	collectionArt233,
	collectionArt234,
	collectionArt235,
	collectionArt236,
	collectionArt237
];
